import request from '@/utils/request.js'
import Cookies from "js-cookie";

export const telegramGroup = window.config.telegramGroup;
export const telegramChannel = window.config.telegramChannel;
export const whatsappNumber = window.config.whatsappNumber;

const config = {
	state: {
        ssid:"",
        error:localStorage.getItem('error')||null,
        kefu_link: '',
	},
	mutations: {
		setConfig (state,data) {
            // console.log(data)
            state.ssid = data.data.ssid;
            state.error = data.data.error
            state.kefu_link = data.data.kefu_link
            state.whatsapp = data.data.whatsapp
            state.app_link = data.data.app_link
            state.tg = data.data.tg
        }
    },
}

export default config
